import { Dispatch } from "redux";
import {
    setAlertEventsSearchResults,
    setAlertEventsSearchResultsLoading
} from "@redux/actions/alert-events-actions";
import { getAlertEventsRequest } from "@requests/alerts/get-alert-events";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { SERVER_DATE_TIME_FORMAT } from "@constants/date-formats";
import { Alert, Assertion, AttributeType, Company, Policy } from "@idw-types/data/reference-data/generic";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { WorkflowConfiguration } from "@idw-types/data/workflow-configuration";
import { formatAlertEventHistories } from "@formatters/alert-event-histories/alert-event-history-formatter";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import format from "date-fns/format";

export const getAlertEventsReduxRequest = (dispatch: Dispatch) => async (
    companyIds: Array<string>,
    alertIds: Array<string>,
    startDate: Date,
    endDate: Date,
    alerts: Array<Alert>,
    companies: Array<Company>,
    rpServices: Array<RpServiceConfiguration>,
    workflows: Array<WorkflowConfiguration>,
    assertions: Array<Assertion>,
    attributeTypes: Array<AttributeType>,
    policies: Array<Policy>
) => {
    dispatch(setAlertEventsSearchResultsLoading(true));
    const { data, error, queryParameters } = await getAlertEventsRequest(
        companyIds,
        alertIds,
        format(startOfDay(startDate), SERVER_DATE_TIME_FORMAT),
        format(endOfDay(endDate), SERVER_DATE_TIME_FORMAT),
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        SERVER_DATE_TIME_FORMAT
    );
    if (data?.alertEventHistories) {
        const formattedAlertEvents = formatAlertEventHistories(
            data.alertEventHistories,
            alerts,
            companies,
            rpServices,
            workflows,
            assertions,
            attributeTypes,
            policies
        );
        dispatch(setAlertEventsSearchResults(formattedAlertEvents));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getAlertEvents.error.title,
                resources.requests.getAlertEvents.error.message,
                null,
                queryParameters
            );
        }
        dispatch(setAlertEventsSearchResultsLoading(false));
    }
};